// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wl4C","inner":"Footer_inner__1HQSS"};